// ✅ firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getMessaging } from "firebase/messaging";
import { getStorage } from "firebase/storage";
import { getAuth , setPersistence, browserLocalPersistence} from "firebase/auth"; // ✅ NEW

// إعدادات Firebase الخاصة بتطبيقك
const firebaseConfig = {
  apiKey: "AIzaSyB2ugVvNF5WGRcaMGvmAUvLBQ2rAwTF3ek",
  authDomain: "artika-tracker.firebaseapp.com",
  projectId: "artika-tracker",
  storageBucket: "artika-tracker.firebasestorage.app",
  messagingSenderId: "120889172969",
  appId: "1:120889172969:web:5f52546e0f8d942810e178",
  measurementId: "G-FQDWMRWJWZ",
};

// 🔥 تهيئة التطبيق لمرة واحدة فقط
const app = initializeApp(firebaseConfig);

// 💾 Firestore
const db = getFirestore(app);

// 📲 Messaging
const messaging = getMessaging(app);

// 🗂️ Storage
const storage = getStorage(app);
const auth = getAuth(app); // ✅ NEW
setPersistence(auth, browserLocalPersistence);

// ✅ تصدير كل شيء حتى يُستخدم في الملفات الأخرى
export { app, db, messaging, storage , auth};
